import { useCallback } from 'react';

import { PatientMedicine } from '@dreryk/egabinet-prescription-frontend-api';

import { Heading, IconWrapper, RemoveIcon } from '@dreryk/react-components';
import { FormContextValues } from '@dreryk/react-common';

import { VisitDiagnoses } from '~libs.shared.visit';
import { protectFeature } from '~libs.shared.system';
import {
   MedicineActiveIngredients,
   MedicineDetailsModalOpenAction,
   MedicineName,
   MedicinePackage,
   MedicineReimbursementSelector,
   MedicineSafetyIndicators,
} from '~libs.desktop.shared.medicine';

import { medicineTranslationKeys } from '../../../../../../../translations';
import { NewMedicineFieldFormBeanPart } from '../NewMedicineField.types';

import { StyledNewMedicineView } from './NewMedicineView.styled';

type NewMedicineViewProps = Pick<FormContextValues<NewMedicineFieldFormBeanPart>, 'setValue'> & {
   patientMedicine: PatientMedicine;
   visitDiagnoses: VisitDiagnoses;
};

export const NewMedicineView = (props: NewMedicineViewProps): JSX.Element => {
   const handleRemove = useCallback((): void => {
      props.setValue('newMedicine', null, { shouldValidate: true, shouldDirty: true });
   }, [props]);

   return (
      <div>
         <Heading
            testId={'newMedicine'}
            type={'h2'}
            content={medicineTranslationKeys.replacement.chooseNewMedicine}
            margin={'0px'}
         />
         <StyledNewMedicineView>
            <div>
               <MedicineDetailsModalOpenAction
                  medicine={props.patientMedicine.medicine}
                  render={(openModal) => (
                     <MedicineName
                        name={props.patientMedicine.medicine.fullName}
                        atc={props.patientMedicine.medicine.atc}
                        onClick={openModal}
                     />
                  )}
               />
               <MedicineActiveIngredients activeIngredients={props.patientMedicine.medicine.activeIngredients} />
               <MedicineReimbursementSelector
                  reimbursements={props.patientMedicine.reimbursements}
                  disabled={false}
                  visitDiagnoses={props.visitDiagnoses}
               />
            </div>
            {protectFeature(
               'extendedMedicineDatabase',
               <MedicineSafetyIndicators medicineId={props.patientMedicine.medicine.id} />,
               <div />
            )}
            <MedicinePackage
               form={props.patientMedicine.medicine.form}
               dose={props.patientMedicine.medicine.dose}
               packageContent={props.patientMedicine.medicine.packageContent}
            />
            <IconWrapper testId={'removeNewMedicine'} onClick={handleRemove}>
               <RemoveIcon />
            </IconWrapper>
         </StyledNewMedicineView>
      </div>
   );
};
